import { getToken, authHeader } from './auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8003';

// ============================================================
// ENDPOINTS PÚBLICOS
// ============================================================

// Registrar nuevo usuario
export async function registrarUsuario(userData) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/registro`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'ngrok-skip-browser-warning': 'true',
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al registrar usuario');
  }

  return response.json();
}

// ============================================================
// ENDPOINTS DE USUARIO AUTENTICADO
// ============================================================

// Obtener perfil del usuario actual
export async function getCurrentUser() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    throw new Error('Error al obtener perfil de usuario');
  }

  return response.json();
}

// Actualizar perfil del usuario actual
export async function actualizarUsuario(userData) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify(userData),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al actualizar usuario');
  }

  return response.json();
}

// Eliminar cuenta del usuario actual (DESACTIVA en lugar de eliminar físicamente)
export async function eliminarUsuario() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me`, {
    method: 'DELETE',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al desactivar cuenta');
  }

  return response.json();
}

// Desactivar cuenta del usuario actual (nuevo endpoint)
export async function desactivarUsuario() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me`, {
    method: 'DELETE',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al desactivar cuenta');
  }

  return response.json();
}

// Obtener créditos disponibles
export async function getCreditos() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me/creditos`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    throw new Error('Error al obtener créditos');
  }

  return response.json();
}

// Consumir un crédito de prueba
export async function consumirCredito() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me/consumir-credito`, {
    method: 'POST',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al consumir crédito');
  }

  return response.json();
}

// Obtener contadores de limitaciones
export async function getContadores() {
  const response = await fetch(`${API_URL}/api/v1/usuarios/me/contadores`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener contadores de limitaciones');
  }

  return response.json();
}

// ============================================================
// ENDPOINTS ADMINISTRATIVOS PARA GESTIÓN DE USUARIOS
// ============================================================

// [ADMIN] Listar todos los usuarios (con paginación)
export async function listarUsuarios(skip = 0, limit = 100) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/admin/usuarios?skip=${skip}&limit=${limit}`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al listar usuarios');
  }

  return response.json();
}

// [ADMIN] Obtener detalle de un usuario específico
export async function obtenerUsuarioPorId(usuarioId) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/admin/usuarios/${usuarioId}`, {
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al obtener usuario');
  }

  return response.json();
}

// [ADMIN] Activar o desactivar un usuario
export async function cambiarEstadoUsuario(usuarioId, activo) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/admin/usuarios/${usuarioId}/estado`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({ activo }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al cambiar estado del usuario');
  }

  return response.json();
}

// [ADMIN] Eliminar un usuario
export async function eliminarUsuarioAdmin(usuarioId) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/admin/usuarios/${usuarioId}`, {
    method: 'DELETE',
    headers: authHeader(),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al eliminar usuario');
  }

  return true;
}

// [ADMIN] Ajustar créditos de un usuario
export async function ajustarCreditosUsuario(usuarioId, creditos) {
  const response = await fetch(`${API_URL}/api/v1/usuarios/admin/usuarios/${usuarioId}/creditos`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...authHeader(),
    },
    body: JSON.stringify({ creditos }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.detail || 'Error al ajustar créditos del usuario');
  }

  return response.json();
}

// ============================================================
// FUNCIÓN AUXILIAR PARA VERIFICAR SI EL USUARIO ES ADMIN
// ============================================================
export function esAdmin(usuario) {
  return usuario && usuario.rol === 'admin';
}